<template>
  <div class="container">
    <div class="register">
      <div style="text-align: center">
        <img src="@/assets/logo.svg" alt="PronAid Logo" style="width: 250px;" />
        <div style="margin: 50px 0;">
          <p>この度はプロンエイドをご利用頂き有難うございます。以下の必須事項とアンケートに記入いただき、本登録を完了してください。</p>
        </div>
      </div>
      {{$route.query.id}}
      <el-form ref="form" :model="form" :rules="rules" label-width="220px">
        <el-form-item label="パスワード" prop="createPassword">
          <el-input
            type="password"
            v-model="form.createPassword"
            suffix-icon="el-icon-fa-lock"
            placeholder="6桁以上の英数字または記号"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item required label="パスワード（確認）" prop="confirmCreatePassword">
          <el-input
            type="password"
            v-model="form.confirmCreatePassword"
            suffix-icon="el-icon-fa-lock"
            placeholder="上と同じものを入力してください"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item required label="お名前">
          <el-input v-model="form.name" placeholder="ご氏名"></el-input>
        </el-form-item>

        <el-form-item label="生年月日（任意）">
          <el-select
            v-model="form.birth.year"
            placeholder="年"
            style="width: 25%;margin-right: 20px;"
          >
            <el-option
              :label="parseInt(new Date().getFullYear())-year.toString() + '年'"
              :value="parseInt(new Date().getFullYear())-year"
              :key="year"
              v-for="year in 100"
            ></el-option>
          </el-select>
          <el-select
            v-model="form.birth.month"
            placeholder="月"
            style="width: 20%;margin-right: 20px;"
          >
            <el-option
              :label="month.toString() + '月'"
              :value="month"
              :key="month"
              v-for="month in 12"
            ></el-option>
          </el-select>
          <el-select v-model="form.birth.date" placeholder="日" style="width: 20%">
            <el-option :label="date.toString() + '日'" :value="date" :key="date" v-for="date in 31"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="TOEICスコア（任意）">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="その他語学試験の結果（任意）">
          <el-select v-model="form.otherTest" placeholder="試験の種類" style="width: 100%">
            <el-option
              :label="test.name"
              :value="index"
              :key="key"
              v-for="(test, index, key) in otherTest"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="`${otherTest[form.otherTest].name}のスコア`"
          v-if="otherTest[form.otherTest] && otherTest[form.otherTest].score"
        >
          <el-input v-model="form.otherTestRusult" placeholder="スコアを数字で入力してください"></el-input>
        </el-form-item>
        <el-form-item
          :label="`${otherTest[form.otherTest].name}の結果`"
          v-if="otherTest[form.otherTest] && !otherTest[form.otherTest].score"
        >
          <el-input v-model="form.otherTestRusult" v-if="otherTest[form.otherTest].score"></el-input>
          <el-select
            v-if="otherTest[form.otherTest] && !otherTest[form.otherTest].score"
            v-model="form.otherTestRusult"
            placeholder="取得した級、グレードを選択してください"
            style="width: 100%"
          >
            <el-option
              :label="grade"
              :value="grade"
              :key="index"
              v-for="(grade, index) in otherTest[form.otherTest].grades"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-alert
          style="margin: 20px 0"
          v-if="true"
          title="確認パスワードが上のパスワードと一致しません"
          type="error"
          :closable="false"
        ></el-alert>

        <div style="text-align: right">
          <button class="button" :class="{'loading': loading}" @click.prevent="register">
            <span v-if="loading">登録中です...</span>
            <span v-else>ユーザー登録を完了する</span>
          </button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import { Loading } from "element-ui";

export default {
  components: {},
  methods: {
    register() {
      this.loading = true;
      let self = this;
      const data = {
        keyCode: this.$route.query.keyCode,
        email: this.$route.query.email,
        password: this.form.createPassword
      };
      const registerVerification = firebase
        .functions()
        .httpsCallable("registerVerification");
      registerVerification(data)
        .then(result => {
          self.loading = false;
          firebase
            .auth()
            .signInWithEmailAndPassword(
              this.$route.query.email,
              self.form.createPassword
            )
            .then(user => {
              this.$router.replace("/dashboard");
            });
        })
        .catch(err => {
          self.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      rules: {
        createPassword: [
          {
            required: true,
            message: "パスワードは必須項目です",
            trigger: "blur"
          },
          {
            min: 6,
            message: "パスワードは6文字以上入力してください",
            trigger: "blur"
          }
        ],
        confirmCreatePassword: [
          {
            required: true,
            message: "パスワードの確認は必須項目です",
            trigger: "blur"
          }
        ]
      },
      otherTest: {
        toefl: {
          name: "TOEFL",
          score: true
        },
        ielts: {
          name: "IELTS(Overall)",
          score: true
        },
        step: {
          name: "英検",
          score: false,
          grades: [
            "準５級",
            "５級",
            "準４級",
            "４級",
            "準３級",
            "３級",
            "準２級",
            "２級",
            "準１級",
            "１級"
          ]
        },
        un: {
          name: "国連英検",
          score: false,
          grades: [
            "準５級",
            "５級",
            "準４級",
            "４級",
            "準３級",
            "３級",
            "準２級",
            "２級",
            "準１級",
            "１級"
          ]
        },
        cambridge: {
          name: "ケンブリッジ英検",
          score: false,
          grades: ["KET", "PET", "FCE", "CAE", "CPE"]
        }
      },
      form: {
        createPassword: "",
        confirmCreatePassword: "",
        name: "",
        birth: {
          year: "",
          month: "",
          date: ""
        },
        otherTest: "",
        otherTestRusult: ""
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
}
.register {
  position: relative;
  width: 600px;
  margin: 0 auto;
  height: 100%;
  p {
  }
}
.loading {
  background-color: #faa;
}
</style>
